module.exports = __webpack_public_path__ + "img/panneauxyes.34b32fee.png";